import React, { useState } from "react";
import { Mail, MapPin, Phone, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";
import Logo from "./Logo";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-black border-t border-zinc-900 pt-20 pb-28 md:pb-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <FooterBrand />
                    <FooterServicesLinks />
                    <FooterCompanyLinks />
                    <NewsletterForm />
                </div>
                <FooterBottom />
            </div>
        </footer>
    );
}

function FooterBrand() {
    return (
        <div className="md:col-span-4">
            <Logo size={220} />
            <p className="text-zinc-400 mt-6 max-w-sm leading-relaxed">
                All tire sizes available — all-weather and winter. Tires, installations,
                brakes, suspension, oil changes and repairs. Retail and wholesale.
            </p>
            <div className="mt-6 space-y-3 text-sm text-zinc-400">
                <div className="flex items-center gap-3"><Phone size={14} className="text-orange-500" /> 647-628-0646</div>
                <div className="flex items-center gap-3"><Mail size={14} className="text-orange-500" /> info@treadmasters.ca</div>
                <div className="flex items-start gap-3"><MapPin size={14} className="text-orange-500 mt-0.5 shrink-0" /> 130 Westmore Dr, Unit 6, Etobicoke, Toronto, ON</div>
            </div>
        </div>
    );
}

function FooterServicesLinks() {
    return (
        <div className="md:col-span-2">
            <h4 className="font-display uppercase text-sm tracking-[0.2em] text-white mb-5">Services</h4>
            <ul className="space-y-3 text-sm text-zinc-400">
                <li><a href="#services" className="hover:text-orange-500" data-testid="footer-services">Tires</a></li>
                <li><a href="#services" className="hover:text-orange-500">Installations</a></li>
                <li><a href="#services" className="hover:text-orange-500">Brakes & Suspension</a></li>
                <li><a href="#services" className="hover:text-orange-500">Oil Changes & Repairs</a></li>
            </ul>
        </div>
    );
}

function FooterCompanyLinks() {
    return (
        <div className="md:col-span-2">
            <h4 className="font-display uppercase text-sm tracking-[0.2em] text-white mb-5">Company</h4>
            <ul className="space-y-3 text-sm text-zinc-400">
                <li><a href="#contact" className="hover:text-orange-500">Book a Service</a></li>
                <li><a href="#wholesale" className="hover:text-orange-500" data-testid="footer-wholesale">Wholesale</a></li>
                <li><a href="#tires" className="hover:text-orange-500">Tire Availability</a></li>
                <li><a href="#location" className="hover:text-orange-500" data-testid="footer-location">Find Us</a></li>
            </ul>
        </div>
    );
}

function NewsletterForm() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await subscribeNewsletter(email);
            toast.success("Subscribed", {
                description: "Maintenance tips & deals are heading your way.",
            });
            setEmail("");
        } catch {
            toast.error("Subscription failed", { description: "Please check your email and try again." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="md:col-span-4">
            <h4 className="font-display uppercase text-sm tracking-[0.2em] text-white mb-5">
                Maintenance Tips & Deals
            </h4>
            <p className="text-zinc-400 text-sm mb-5">
                Seasonal swap reminders, insider deals, and pro driving tips.
            </p>
            <form onSubmit={onSubmit} className="flex gap-2" data-testid="newsletter-form">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@road.com"
                    required
                    data-testid="newsletter-email-input"
                    className="flex-1 bg-zinc-900 border border-zinc-700 focus:border-orange-600 focus:outline-none text-white px-4 py-3 rounded-sm font-mono text-sm"
                />
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="newsletter-submit"
                    className="bg-orange-600 hover:bg-orange-500 disabled:opacity-60 text-white px-5 rounded-sm flex items-center gap-2 font-display uppercase tracking-[0.18em] text-xs"
                >
                    {loading ? "..." : <>Join <ArrowRight size={14} /></>}
                </button>
            </form>
        </div>
    );
}

function FooterBottom() {
    return (
        <div className="mt-16 pt-8 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-zinc-600 text-xs font-mono uppercase tracking-[0.2em]">
                © {new Date().getFullYear()} TreadMasters · Canada Compliant · 3PMSF Certified
            </div>
            <div className="flex gap-6 text-xs text-zinc-500 uppercase tracking-[0.18em]">
                <a href="#">Privacy</a>
                <a href="#">Terms</a>
                <a href="#">Returns</a>
            </div>
        </div>
    );
}
